// Use window.$ directly to avoid timing issues with jQuery loading
var $ = window.$ || window.jQuery;

$(document).ready(function() {
  
});